import React, { Component } from "react";
import "./Listdb.scss";
import './SearchPage.scss';
import { compose } from "redux";
import { connect } from "react-redux";
import { HOME } from "../helpers/path";

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuote: '',
            listSearch: []
        }
    }

    filterSearch = (search) => {
        const { listSearch } = this.state;
        const { list } = this.props;
        let listTemp = [];
        if (search) {
            listTemp = [];
            list.map((item) => {
                // let itemQuote = this.removeVnSign(item.quote);
                // let searchQuote = this.removeVnSign(search)
                if (this.removeVnSign(item.quote).includes(this.removeVnSign(search))) {
                    listTemp.push(item);
                }
            })
            this.setState({
                listSearch: [...listTemp]
            })
        } else {
            this.setState({
                listSearch: []
            })
        }
    }

    removeVnSign = (text) => {
        let convertText = text
            .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a')
            .replace(/[èéẹẻẽêềếệểễ]/g, 'e')
            .replace(/[ìíịỉĩ]/g, 'i')
            .replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o')
            .replace(/[ùúụủũưừứựửữ]/g, 'u')
            .replace(/[ỳýỵỷỹ]/g, 'y')
            .replace(/[đ]/g, 'd')
            .replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, 'A')
            .replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, 'E')
            .replace(/[ÌÍỊỈĨ]/g, 'I')
            .replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, 'O')
            .replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, 'U')
            .replace(/[ỲÝỴỶỸ]/g, 'Y')
            .replace(/[Đ]/g, 'D')
            .trim()
            .toLowerCase();
        return convertText;
    }

    searchFn = (value) => {
        this.setState({
            searchQuote: value
        }, () => {
            this.filterSearch(this.state.searchQuote)
        })
    }

    render() {
        const { listSearch } = this.state;
        return (
            <React.Fragment>
                <div className="text-center">
                    <h1>Search</h1>
                    <button className="backToHome" onClick={() => this.props.history.replace(HOME)}>back</button>
                </div>
                <div className="listSearch">
                    <input className="input_quote" placeholder="tìm kiếm" onChange={(e) => {
                        this.searchFn(e.target.value)
                    }} type="text" value={this.state.searchQuote} />
                    {listSearch.map((item, index) => {
                        return <textarea key={index} disabled className="quoteSearch" value={item.quote} />
                    })}
                </div>
            </React.Fragment>
        );
    }
}

const withStore = connect(
    (state) => ({
        list: state.quotes.listQuote,
    }),
    null
);

export default compose(withStore)(SearchPage);
